module.exports = __webpack_public_path__ + "assets/img/1.513f5f49.jpg";